import "react";
import { DinnerTable } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/components/AuditLogs/AuditLogTable/TableHeadRow.tsx
function AuditLogTableHeadRow({ showUser }) {
	return /* @__PURE__ */ jsx(DinnerTable.Header, { children: /* @__PURE__ */ jsxs(DinnerTable.Row, {
		isHeader: true,
		children: [
			/* @__PURE__ */ jsx(DinnerTable.Cell, {
				isHeader: true,
				children: "Date"
			}),
			showUser && /* @__PURE__ */ jsx(DinnerTable.Cell, {
				isHeader: true,
				children: "User"
			}),
			/* @__PURE__ */ jsx(DinnerTable.Cell, {
				isHeader: true,
				children: "Action"
			}),
			/* @__PURE__ */ jsx(DinnerTable.Cell, {
				isHeader: true,
				children: "Title"
			}),
			/* @__PURE__ */ jsx(DinnerTable.Cell, {
				isHeader: true,
				children: "Device"
			})
		]
	}) });
}
//#endregion
export { AuditLogTableHeadRow };

//# sourceMappingURL=TableHeadRow.js.map